"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapTo = mapTo;

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Subscriber2 = require("../Subscriber");

/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */
function mapTo(value) {
  return function (source) {
    return source.lift(new MapToOperator(value));
  };
}

var MapToOperator =
/*#__PURE__*/
function () {
  function MapToOperator(value) {
    (0, _classCallCheck2.default)(this, MapToOperator);
    this.value = value;
  }

  (0, _createClass2.default)(MapToOperator, [{
    key: "call",
    value: function call(subscriber, source) {
      return source.subscribe(new MapToSubscriber(subscriber, this.value));
    }
  }]);
  return MapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */


var MapToSubscriber =
/*#__PURE__*/
function (_Subscriber) {
  (0, _inherits2.default)(MapToSubscriber, _Subscriber);

  function MapToSubscriber(destination, value) {
    var _this;

    (0, _classCallCheck2.default)(this, MapToSubscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MapToSubscriber).call(this, destination));
    _this.value = value;
    return _this;
  }

  (0, _createClass2.default)(MapToSubscriber, [{
    key: "_next",
    value: function _next(x) {
      this.destination.next(this.value);
    }
  }]);
  return MapToSubscriber;
}(_Subscriber2.Subscriber);